import { render, staticRenderFns } from "./textdetail.vue?vue&type=template&id=6129d5a4&scoped=true&"
import script from "./textdetail.vue?vue&type=script&lang=js&"
export * from "./textdetail.vue?vue&type=script&lang=js&"
import style0 from "./textdetail.vue?vue&type=style&index=0&id=6129d5a4&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129d5a4",
  null
  
)

export default component.exports